<div class="cx-one-ui etl-data-feed-container mx-6" *ngIf="showDataFeedLandingPage">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>
    <div class="header-container" id="header-container">
        <div class="page-title" data-qa="cxone-etl-data-feed-title" cvLocalizedText langSection="ETL_Data_Feed" langKey="Data_Feed">Data Feed</div>
        <div>
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white mr-3" (click)="onRowAction('failed-imports')"
                cvLocalizedText langSection="ETL_Data_Feed" langKey="Failed_Imports" *ngIf="showFailedImportBtn">
                Failed Imports
            </button>
            <button class="cxone-btn btn-big btn-primary" cvLocalizedText langSection="ETL_Data_Feed"
                langKey="New_Data_Feed" (click)="onRowAction('create')" *ngIf="showNewDataFeedBtn">New Data Feed</button>
        </div>
    </div>
    <div class="data-feed-details">
        <cxone-omnibar [itemCountLabel]="dataFeedLabel" [isFilterable]="false"
            [searchPlaceholderText]="searchPlaceholderText" (searchQueryChange)="onSearchCriteriaChange($event)"
            [searchQuery]="searchInput">
        </cxone-omnibar>
        <cxone-grid class="content-container" [gridOptions]="dataFeedGridOptions" *ngIf="isLocalizationSectionLoaded">
        </cxone-grid>
    </div>
</div>
<div *ngIf="showDataFeedViewPage">
    <cv-cxone-etl-data-feed-view (backAction)="onRowAction()"
        [selectedDataFeed]="selectedDataFeed"></cv-cxone-etl-data-feed-view>
</div>
<div *ngIf="showFailedImports">
    <cv-failed-import-report [pageTitle]="pageTitle" [apiType]="apiType"
        (backAction)="onRowAction()"></cv-failed-import-report>
</div>

<div *ngIf="showCreateNewDataFeedPage">
    <cv-create-edit-data-feed (backAction)="onRowAction()" [isEditable]="isEditable || canEditLocked" [isPreview]="isPreview"
        [selectedDataFeed]="selectedDataFeed" [dataFeedGridData]="dataFeedGridData"></cv-create-edit-data-feed>
</div>
